import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { fetchAvailabilityBlocks } from '@mews-commander/legacy-entities/src/actions/availabilityBlocks';
import { getAvailabilityBlock } from '@mews-commander/legacy-entities/src/ducks/availabilityBlocks';
import { getEnterpriseIdFromServiceId } from '@mews-commander/legacy-entities/src/ducks/services';

export const prefetchAvailabilityBlockDashboard = async (
    dispatch: CommanderThunkDispatch,
    state: ApplicationState,
    availabilityBlockId: string
) => {
    const enterpriseId = getCurrentEnterpriseId();

    await dispatch(
        fetchAvailabilityBlocks({
            availabilityBlockIds: [availabilityBlockId],
            enterpriseIds: [enterpriseId],
        })
    );
};

export const checkAvailabilityBlockDashboardPrivilege = (state: ApplicationState, availabilityBlockId: string) => {
    const availabilityBlock = getAvailabilityBlock(state, { id: availabilityBlockId });
    if (!availabilityBlock) {
        return false;
    }
    const enterpriseId = getCurrentEnterpriseId();
    const blockEnterpriseId = getEnterpriseIdFromServiceId(state, { serviceId: availabilityBlock.serviceId });

    return enterpriseId === blockEnterpriseId;
};
